import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { ParticipantTabNavs } from "@/shared/components/tabNavs";
import Users from "./components/Users";
import { isEmpty } from "@/shared/helpers";
import Sidebar from "@/containers/Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import { useTranslation } from "react-i18next";

const CLASSIC_IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

const Peer2Peer = ({ auth, program, organization, template, pointBalance }) => {
  const { t } = useTranslation();
  const showUsers = auth && program && !isEmpty(organization);

  const Peer2PeerClear = () => (
    <div className="peer-page">
      <div className="peer-page__header">
        <Container>
          <div className="peer-page__header-inner">
            <div>
              <h1 className="peer-page__title">{t("reward_a_peer")}</h1>
              <p className="peer-page__desc">{t("reward_desc")}</p>
            </div>
          </div>
        </Container>
      </div>

      <Container className="peer-page__body">
        <ClearPageLayout>
          {showUsers && (
            <Users
              organization={organization}
              program={program}
              pointBalance={pointBalance}
            />
          )}
        </ClearPageLayout>
      </Container>
    </div>
  );

  const Peer2PeerClassic = () => (
    <>
      <div className="mainboard">
        <img src={CLASSIC_IMG_BACK} alt={t("reward_a_peer")} />
        <div className="title">{t("reward_a_peer")}</div>
      </div>

      <Container>
        <ParticipantTabNavs />
      </Container>

      <Container>
        <Row>
          <Col md={9}>
            <div className="dashboard">
              <div className="peer-page__classic-intro">
                <h3>{t("reward_a_peer")}</h3>
                <p>{t("reward_desc")}</p>
              </div>
              {showUsers && (
                <Users
                  organization={organization}
                  program={program}
                  pointBalance={pointBalance}
                />
              )}
            </div>
          </Col>
          <Col md={3}>
            <Sidebar />
          </Col>
        </Row>
      </Container>
    </>
  );

  return (
    (template?.name === "clear" && <Peer2PeerClear />) ||
    (template?.name === "classic" && <Peer2PeerClassic />) ||
    <Peer2PeerClear />
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  program: state.program,
  organization: state.organization,
  template: state.template,
  pointBalance: state.pointBalance,
});

export default connect(mapStateToProps)(Peer2Peer);
